"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16PeopleAddLine = function Svg16PeopleAddLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 20a2 2 0 0 0 2-2c0-.5-.13-.954-.13-.954a4.891 4.891 0 0 0-.832-1.746C16.52 13.943 14.738 13 12 13c-2.738 0-4.52.943-5.537 2.3a4.892 4.892 0 0 0-.833 1.746S5.5 17.5 5.5 18a2 2 0 0 0 2 2h9zm0-2s0-1.127-1.037-2c-.654-.55-1.722-1-3.463-1s-2.809.45-3.463 1C7.5 16.873 7.5 18 7.5 18h9zM16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M17.453 13.109c1.382.221 2.413.772 3.115 1.574.55.629.932 1.47.932 2.317a2 2 0 0 1-1.635 1.967A3.5 3.5 0 0 0 20 18l-.005-.209c-.061-1.218-.528-2.419-1.258-3.391a6.551 6.551 0 0 0-1.284-1.291z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 8.5a3.5 3.5 0 0 1-3.718 3.493A5.485 5.485 0 0 0 17.5 8c0-1.081-.312-2.09-.85-2.94A3.501 3.501 0 0 1 19.5 8.5z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M6.25 10.25a1 1 0 0 0-2 0V11H3.5a1 1 0 1 0 0 2h.75v.75a1 1 0 1 0 2 0V13H7a1 1 0 1 0 0-2h-.75v-.75z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16PeopleAddLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16PeopleAddLine;
exports.default = _default;